import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

// CONSTANTS
import colors from '../_constants/colors'
import { tenantColors } from '../_constants/colors'
import { formConfig } from '../_configs/formConfig/form.config'

const BreadcrumbComponent = styled.div`
  display: flex;
  overflow: hidden;

  @media screen and (min-width: 600px) {
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
`

const Crumb = styled(Link)`
  display: flex;
  width: 100%;
  justify-content: center;
  grid-gap: 5px;
  align-items: center;
  background-color: ${colors.GREY};
  color: ${(props) => (props.disabled ? `rgba(0,0,0,0.25)` : `black`)};
  border: 1px solid ${colors.DARK_GREY};
  padding: 15px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  pointer-events: ${(props) => (props.disabled ? `none` : `auto`)};

  &:hover {
    text-decoration: underline;
    background-color: ${colors.DARK_GREY};
  }

  &.is-active {
    background-color: white;
  }
`

const ActiveIndicator = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 100px;
  background-color: ${(props) => {
    return tenantColors[props.tenant].primary || colors.FINVOICE_BLUE
  }};
  margin-right: 0.3em;
`

const Breadcrumbs = ({ activeItem, completed_profile, tenant }) => {
  const items = formConfig[tenant].crumbs
  return (
    <BreadcrumbComponent className="breadcrumbs">
      {items.map((item, i) => (
        <Crumb
          className={`crumb ${activeItem === item.label && 'is-active'}`}
          disabled={item.label === `Submitted` && !completed_profile}
          key={i}
          to={item.link}
        >
          {activeItem === item.label && (
            <ActiveIndicator className="active-indicator" tenant={tenant}></ActiveIndicator>
          )}
          <span>{item.label}</span>
        </Crumb>
      ))}
    </BreadcrumbComponent>
  )
}

function mapStateToProps(state) {
  const { business, env } = state
  return {
    completed_profile: business.completed_profile,
    tenant: env.tenant,
  }
}

const connectedBreadcrumbs = connect(mapStateToProps)(Breadcrumbs)
export { connectedBreadcrumbs as Breadcrumbs }
